import { render, staticRenderFns } from "./CallActionCard.vue?vue&type=template&id=56bf7015&scoped=true&"
import script from "./CallActionCard.vue?vue&type=script&lang=js&"
export * from "./CallActionCard.vue?vue&type=script&lang=js&"
import style0 from "./CallActionCard.vue?vue&type=style&index=0&id=56bf7015&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bf7015",
  null
  
)

export default component.exports